import { NavLink, useNavigate } from "react-router-dom";

const items = [
  { label: "首页", to: "/", icon: "ri-home-5-line" },
  { label: "电影", to: "/category/movie", icon: "ri-film-line" },
  { label: "电视剧", to: "/category/tv", icon: "ri-tv-2-line" },
  { label: "综艺", to: "/category/variety", icon: "ri-mic-line" },
];

export default function MobileBottomNav() {
  const navigate = useNavigate();

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-background-50/95 backdrop-blur border-t border-background-200">
      <div className="flex items-stretch justify-around">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === "/"}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center gap-1 py-2.5 cursor-pointer ${
                isActive ? "text-primary-600" : "text-foreground-500"
              }`
            }
          >
            <i className={`${item.icon} text-xl`}></i>
            <span className="text-[11px]">{item.label}</span>
          </NavLink>
        ))}
        <button
          type="button"
          onClick={() => navigate("/search")}
          className="flex-1 flex flex-col items-center justify-center gap-1 py-2.5 text-foreground-500 cursor-pointer"
        >
          <i className="ri-search-line text-xl"></i>
          <span className="text-[11px]">搜索</span>
        </button>
      </div>
    </div>
  );
}